var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { BaseReportItemComponent } from '../../models/base-report-item-component';
var AssessmentQuestionsListComponent = /** @class */ (function (_super) {
    __extends(AssessmentQuestionsListComponent, _super);
    function AssessmentQuestionsListComponent() {
        return _super.call(this) || this;
    }
    AssessmentQuestionsListComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(AssessmentQuestionsListComponent.prototype, "assessment", {
        get: function () {
            return this._assessment;
        },
        enumerable: true,
        configurable: true
    });
    AssessmentQuestionsListComponent.prototype.setReportData = function (data, results, variables) {
        if (data.assessment && results) {
            var assessmentResult = results.find(function (r) { return r.assessment.uid == data.assessment; });
            this._assessment = assessmentResult ? assessmentResult.assessment : null;
        }
        if (data.title) {
            this._title = data.title;
        }
        else {
            this._title = this._assessment.name;
        }
    };
    AssessmentQuestionsListComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    AssessmentQuestionsListComponent.prototype.getTitle = function () {
        return this._title;
    };
    AssessmentQuestionsListComponent.prototype.getQuestionsForAssessment = function () {
        if (!this._assessment) {
            return [];
        }
        var questions = this._assessment.question_sets
            .map(function (qs) { return qs.questions; })
            .reduce(function (a, b) { return a.concat(b); }, []);
        return questions;
    };
    return AssessmentQuestionsListComponent;
}(BaseReportItemComponent));
export { AssessmentQuestionsListComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/assessment-questions-list/assessment-questions-list.component.ts.pre-build-optimizer.js